module.exports = __webpack_public_path__ + "img/Grinswettbewerb.9799bb4e.svg";